const bedc = [
	'bedc:customer:create:{organizationId}',
	'bedc:customer:create-simple:{organizationId}',
	'bedc:customer:read',
	'bedc:customer:lookup',
	'bedc:customer:list',
	'bedc:customer:search',
	'bedc:customer:update',
] as const;

const integration = [
	'integration:customer:create:{organizationId}',
	'integration:customer:read',
	'integration:customer:list',
	'integration:customer:update',

	'integration:customer:read:{organizationId}/file',
	'integration:customer:create:{organizationId}/file',
	'integration:customer:delete:{organizationId}/file',
] as const;

export default [...bedc, ...integration] as const;
